<template>
	<div class="editPreInfo">
		<el-card>
			<div class="jump-btn">
				<el-button type="primary" @click="back">{{$t('lang.venue.btn_back_venue_management')}}</el-button>
			</div>
			<el-form :model="editForm" :rules="rules" ref="editForm" class="wid100"
				:label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon">
				<!-- <el-form-item :label="$t('lang.venue.label_customNo')" prop="customNo">
          <el-input v-model="editForm.customNo" :placeholder="$t('lang.venue.tip_input_customNo')" class="item-input" maxlength="24"></el-input>
        </el-form-item> -->
				<!-- 资源点位连接地址 -->
				<el-form-item label="资源点位链接地址" prop="url" v-if="!this.isAdd&&this.editForm.id != ''&&this.editForm.url">
					<el-input v-model="editForm.url" :disabled='true' class="item-input"></el-input>
				</el-form-item>
				<!-- 设备二维码 -->
				<el-form-item label="资源点位二维码" v-if="!this.isAdd&&this.editForm.id != ''&&this.editForm.url">
					<div class="qrcode" ref="qrCodeUrl"></div>
				</el-form-item>
				<el-form-item :label="$t('lang.venue.label_customName')" prop="customName">
					<el-input v-model="editForm.customName" :placeholder="$t('lang.venue.tip_input_customName')"
						class="item-input" maxlength="24"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.venue.label_attribute')" prop="type">
					<el-select v-model="editForm.type" :placeholder="$t('lang.venue.tip_select_attribute')">
						<el-option key :label="$t('lang.venue.tip_select_attribute')" :value="zero"></el-option>
						<el-option v-for="(item, index) in attrArr" :key="index" :value="item.num" :label="item.name"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="面积/规格" prop="area">
					<el-input v-model="editForm.area" :placeholder="$t('lang.venue.tip_input_area')" class="item-input"
						maxlength="24" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
				</el-form-item>

				<!-- 开始日期 -->
				<!-- <el-form-item :label="$t('lang.venue.tip_select_startDate')" prop="startDate">
					<el-date-picker class="authority" v-model="editForm.startDate" type="date" value-format='timestamp'
						:placeholder="$t('lang.venue.tip_select_startDate')">
					</el-date-picker>
				</el-form-item> -->

				<!-- 截止日期 -->
				<!-- <el-form-item :label="$t('lang.venue.tip_select_endDate')" prop="endDate">
					<el-date-picker class="authority" v-model="editForm.endDate" type="date" value-format='timestamp'
						:placeholder="$t('lang.venue.tip_select_endDate')">
					</el-date-picker>
				</el-form-item> -->

				<el-form-item :label="$t('lang.venue.label_position')" prop="position">
					<el-input v-model="editForm.position" :placeholder="$t('lang.venue.tip_input_position')" class="item-input"
						maxlength="40"></el-input>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_resourceType')" prop="firstResourceType">
					<el-select @change="selectFirstResource" v-model="editForm.firstResourceType">
						<el-option key :label="$t('lang.venue.tip_select_firstResource')" :value="zero"></el-option>
						<el-option v-for="(item,index) in resourceArr" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_secResourceType')" prop="secResourceType">
					<el-select v-model="editForm.secResourceType">
						<el-option key :label="$t('lang.venue.tip_select_secResource')" :value="zero"></el-option>
						<el-option v-for="(item,index) in secResourceArr" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- 供应商选择 -->
				<el-form-item label="供应商名称" prop="supplierId">
					<el-select v-model="editForm.supplierId" @change="selectSupplier" placeholder="请选择供应商">
						<el-option v-for="(item,index) in supplierList" :key="index" :value="item.id" :label="item.supplierName">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item :label="$t('lang.venue.label_supplierName')" prop="supplierName">
					<el-input v-model="editForm.supplierName" :placeholder="$t('lang.venue.tip_input_supplierName')"
						class="item-input" maxlength="24"></el-input>
				</el-form-item> -->

				<el-form-item :label="$t('lang.venue.label_contactName')" prop="contactName">
					<el-input v-model="editForm.contactName" :placeholder="$t('lang.venue.tip_input_contactName')"
						class="item-input" maxlength="24" disabled></el-input>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_contactNumber')" prop="contactNumber">
					<el-input v-model="editForm.contactNumber" :placeholder="$t('lang.venue.tip_input_contactNumber')"
						class="item-input" maxlength="11" disabled></el-input>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_entrance')" prop="entrance">
					<el-input v-model="editForm.entrance" :placeholder="$t('lang.venue.tip_input_entrance')" class="item-input"
						maxlength="24"></el-input>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_house')" prop="houseId">
					<el-select v-model="editForm.houseId" @change="getListUnit">
						<el-option key :label="$t('lang.venue.tip_select_house')" :value="zero"></el-option>
						<el-option v-for="(item, index) in houseArr" :key="index" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('lang.venue.label_unit')" prop="unitId">
					<el-select v-model="editForm.unitId">
						<el-option key :label="$t('lang.venue.tip_select_unit')" :value="zero"></el-option>
						<el-option v-for="(item, index) in unitArr" :key="index" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_lift')" prop="lift">
					<el-input v-model="editForm.lift" :placeholder="$t('lang.venue.tip_input_lift')" class="item-input"
						maxlength="24"></el-input>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_healthLevel')" prop="health">
					<el-select v-model="editForm.health">
						<!-- <el-option key :label="$t('lang.venue.tip_select_health')" :value="zero-2"></el-option> -->
						<el-option v-for="(item,index) in healthArr" :key="index" :value="item.num" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_status')" prop="status">
					<el-select v-model="editForm.status">
						<!-- <el-option key :label="$t('lang.venue.tip_select_status')" :value="zero-1"></el-option> -->
						<el-option v-for="(item,index) in statusArr" :key="index" :value="item.num" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- 合同选择 -->
				<el-form-item label="合同名称" prop="contractId">
					<el-select v-model="editForm.contractId" @change="selectContract" placeholder="请选择合同">
						<el-option v-for="(item,index) in contractList" :key="index" :value="item.id" :label="item.contractName">
						</el-option>
					</el-select>
					<span v-if="showTips" style="color:red;margin-left:10px;">合同已经到期，请重新选择合同</span>
				</el-form-item>
				<el-form-item :label="$t('lang.venue.label_basePrice')" prop="basePrice">
					<el-input v-model="editForm.basePrice" :placeholder="$t('lang.venue.tip_input_basePrice')" class="item-input"
						maxlength="20" disabled></el-input>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_customPrice')" prop="customPrice">
					<el-input v-model="editForm.customPrice" :placeholder="$t('lang.venue.tip_input_customPrice')"
						class="item-input" maxlength="20"></el-input>
				</el-form-item>
				<!-- 合同开始日期 -->
				<el-form-item label="合同生效日期" prop="startDate">
					<el-date-picker class="authority" v-model="editForm.contractInfo.startDate" type="date"
						value-format='timestamp' placeholder="合同生效日期">
					</el-date-picker>
				</el-form-item>

				<!-- 合同截止日期 -->
				<el-form-item label="合同截止日期" prop="endDate">
					<el-date-picker class="authority" v-model="editForm.contractInfo.endDate" type="date" value-format='timestamp'
						placeholder="合同截止日期">
					</el-date-picker>
				</el-form-item>

				<el-form-item :label="$t('lang.venue.label_remark')" prop="remark">
					<el-input v-model="editForm.remark" :placeholder="$t('lang.venue.tip_input_remark')" class="item-input">
					</el-input>
				</el-form-item>

				<!-- 上传图片 -->
				<el-form-item :label="$t('lang.lab_uploadPhotograph')">
					<upload-morefile ref="uploading" :fileList='fileslist' upTypes='1' :clears='clears' @outputFile="getFile"
						@removeFile='removeFile'></upload-morefile>
				</el-form-item>

				<!-- <el-button class="btn-first" @click="resetForm('editForm')">{{$t('lang.btn_rest')}}</el-button> -->
				<el-button class="detailbtn" type="primary" @click="save()" :disabled="isDisabled && isDisabled2">
					{{$t('lang.btn_save')}}</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import QRCode from 'qrcodejs2'
	import uploadmoreFile from '../../components/upload_morefile.vue'
	var nowDate = new Date().getTime()
	export default {
		data() {
			const isPhone = (rule, value, callback) => {
				let phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
				let telePhone = /^0[1|2|3|4|5|6|7|8|9][1|2|3|4|5|6|7|8|9][1|2|3|4|5|6|7|8|9]-\d{8}$/
				if (value === 0 || value === '' || phone.test(value) || telePhone.test(value)) {
					callback()
				} else {
					callback(
						new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
					)
				}
			}
			const validateMoney = (rule, value, callback) => {
				if (!value) {
					callback()
				} else if (value.indexOf('.') != -1 && value.split('.').length > 2) {
					callback(new Error('请输入正确格式的金额')) // 防止输入多个小数点
				} else if (value.indexOf('.') != -1 && value.split('.')[1].length > 2) {
					callback(new Error('请输入正确的小数位数')) // 小数点后两位
				} else {
					callback()
				}
			}
			return {
				clears: false,
				accept: '.jpg, .jpeg, .png',
				zero: 0, // 值为0的变量
				editForm: {
					id: '',
					customNo: '',
					customName: '',
					type: 0,
					area: '',
					startDate: '',
					endDate: '',
					position: '',
					firstResourceType: 0,
					secResourceType: 0,
					supplierName: '',
					contactName: '',
					contactNumber: '',
					entrance: '',
					gardenId: 0,
					houseId: '',
					unitId: 0,
					liftId: '',
					lift: '',
					health: 0,
					status: 0,
					basePrice: '',
					customPrice: '',
					remark: '',
					supplierId: '',
					contractId: '',
					contractInfo: {},
				},
				fileslist: [], // 图片list
				fileList: [], // 图片list
				rules: {
					customName: [{
						required: true,
						message: this.$i18n.t('lang.venue.tip_input_customName'),
						trigger: 'blur'
					}],
					position: [{
						required: true,
						message: this.$i18n.t('lang.venue.tip_input_position'),
						trigger: 'blur'
					}]
					/* ,
									contactNumber: [{ validator: isPhone, trigger: 'blur' }] */
				},
				resourceArr: [],
				secResourceArr: [],
				houseArr: [],
				unitArr: [],
				attrArr: [{
					num: 1,
					name: '租赁'
				}, {
					num: 2,
					name: '自营'
				}, {
					num: 3,
					name: '合作'
				}, {
					num: 4,
					name: '内部服务'
				}],
				healthArr: [{
					num: 1,
					name: '健康'
				}, {
					num: 0,
					name: '良好'
				}, {
					num: -1,
					name: '损坏'
				}],
				statusArr: [{
					num: 1,
					name: '营业'
				}, {
					num: 0,
					name: '未营业'
				}],
				saveData: '',
				saveUrls: '',
				isDisabled: true, // 保存的可点击,
				isDisabled2: true, // 保存的可点击
				supplierList: [], // 供应商列表
				contractList: [], // 合同列表
				showTips: false, // 合同到期提示
				oldContractId: '', // 修改前合同id
			}
		},
		components: {
			'upload-morefile': uploadmoreFile
		},
		created() {
			this.editForm.gardenId = this.$store.getters.gardenId
			this.isAdd = this.$route.query.flag
			let jsonStr = this.$route.query.venueData
			if (typeof (jsonStr) == 'string') {
				this.$router.push({
					name: 'venueList'
				})
				return false
			}
			if (jsonStr) {
				this.saveData = JSON.stringify(jsonStr)
				this.oldContractId = jsonStr.contractId
				this.editForm = jsonStr
				if (this.editForm.supplierId == 0) {
					this.editForm.supplierId = ''
				}
				if (this.editForm.contractId == 0) {
					this.editForm.contractId = ''
				}
				console.log(this.editForm)
				// 合同到期提示
				if (this.editForm.contractInfo && nowDate > this.editForm.contractInfo.endDate) {
					this.showTips = true
				}
				if (!this.editForm.contractInfo) {
					this.editForm.contractInfo = {}
					this.editForm.contractInfo.startDate = ''
					this.editForm.contractInfo.endDate = ''
				}

				// 生成设备二维码
				this.$nextTick(function () {
					this.creatQrCode()
				})
			} else {
				this.editForm.contractInfo.startDate = ''
				this.editForm.contractInfo.endDate = ''
			}
			this.getResource(0)
			if (this.editForm.firstResourceType != 0) {
				this.getResource(this.editForm.firstResourceType)
			}
			this.getListHouse()
			if (this.editForm.houseId > 0) {
				this.getListUnit()
			}
			if (this.editForm.id > 0) {
				this.getVenueFiles()
			}
			this.getSupplierList()
			this.getContractList()
		},
		watch: {
			editForm: {
				handler(newVal, oldVal) {
					// form数据变化时 会调用此方法
					let tempRule = JSON.stringify(newVal)
					if (tempRule == this.saveData) {
						// 没变
						this.isDisabled = true
					} else {
						// 变了
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			},
			fileList: {
				handler(newVal, oldVal) {
					// form数据变化时 会调用此方法
					let tempRule = JSON.stringify(newVal)
					console.log('newVal : ' + tempRule)
					console.log('oldVal : ' + this.saveUrls)
					if (tempRule == this.saveUrls) {
						// 没变
						this.isDisabled2 = true
					} else {
						// 变了
						this.isDisabled2 = false
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			// 生成资源点位二维码
			creatQrCode() {
				let that = this
				let qrcode = new QRCode(that.$refs.qrCodeUrl, {
					text: that.editForm.url, // 需要转换为二维码的内容
					width: 100,
					height: 100,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
				console.log(qrcode)
			},
			// 返回
			back() {
				this.$router.push({
					name: 'venueList'
				})
			},
			getVenueFiles() {
				let loading = this.$loading()
				this.$get('/venue/getVenueFiles?id=' + this.editForm.id)
					.then(res => {
							loading.close()
							console.log('res : ' + JSON.stringify(res))
							for (let item of res.urls) {
								this.fileslist.push({
									name: '',
									url: item
								})

								this.fileList.push({
									name: '',
									url: item
								})
							}
							this.saveUrls = JSON.stringify(this.fileslist)
							console.log('res : ' + JSON.stringify(this.fileslist))
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
			},
			getResource(parentId) {
				let loading = this.$loading()
				this.$get('/venue/getTypes' + (parentId > 0 ? ('?parentId=' + parentId) : ''))
					.then(res => {
							if (parentId > 0) {
								loading.close()
								this.secResourceArr = res.list
							} else {
								this.resourceArr = res.list
							}
						},
						error => {
							if (parentId > 0) {
								loading.close()
							}
							this.$message.error(error)
						})
			},
			selectFirstResource(value) {
				if (value) {
					console.log('First : ' + value)
					this.getResource(value)
				}
			},
			// 获取小区下的楼号
			getListHouse() {
				if (this.isAdd) {
					this.editForm.houseId = 0
					this.houseArr = []
					this.editForm.unitId = 0
					this.unitArr = []
				}
				let loading = this.$loading()

				if (this.editForm.gardenId > 0) {
					this.$get(`/gardenGrids?type=1&parentId=${this.editForm.gardenId}&pageNo=1&pageSize=9999`).then(res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.houseArr = res.list
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
				}
			},
			// 获取楼号下的单元号
			getListUnit() {
				if (this.isAdd) {
					this.editForm.unitId = 0
					this.unitArr = []
				}
				if (this.editForm.houseId > 0) {
					let loading = this.$loading()
					this.$get(`/gardenGrids?type=2&parentId=${this.editForm.houseId}&pageNo=1&pageSize=999`).then(res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.unitArr = res.list
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
				}
			},
			save() {
				this.$refs['editForm'].validate(valid => {
					if (valid) {
						// 上传图片
						this.fileslist = []
						if (this.fileList.length > 0) {
							for (let i = 0; i < this.fileList.length; i++) {
								this.fileslist.push(this.fileList[i].url)
							}
						}
						if (this.editForm.startDate && this.editForm.endDate) {
							if (this.editForm.startDate > this.editForm.endDate) {
								this.$message.error('开始日期不能大于截止日期')
								return
							}
						}
						if (this.editForm.contractId && !this.editForm.supplierId) {
							this.$message.info('请选择供应商')
							return
						}
						if (this.isAdd) {
							let params = {
								customName: this.editForm.customName,
								customNo: this.editForm.customNo,
								type: this.editForm.type,
								area: this.editForm.area,
								startDate: this.editForm.startDate,
								endDate: this.editForm.endDate,
								position: this.editForm.position,
								firstResourceType: this.editForm.firstResourceType,
								secResourceType: this.editForm.secResourceType,
								supplierName: this.editForm.supplierName,
								contactName: this.editForm.contactName,
								contactNumber: this.editForm.contactNumber,
								entrance: this.editForm.entrance,
								gardenId: this.editForm.gardenId,
								houseId: this.editForm.houseId,
								unitId: this.editForm.unitId,
								lift: this.editForm.lift,
								health: this.editForm.health,
								status: this.editForm.status,
								basePrice: this.editForm.basePrice,
								customPrice: this.editForm.customPrice,
								remark: this.editForm.remark,
								files: this.fileslist.toString(),
								supplierId: this.editForm.supplierId,
								contractId: this.editForm.contractId,
							}
							let loading = this.$loading()
							this.$post(`/venue/createVenue`, params).then(
								res => {
									loading.close()
									console.log(res)
									if (res && res.errCode === 0) {
										// 如果供应商id和合同id不为空，则上传记录
										if (this.editForm.supplierId != '' && this.editForm.contractId != '') {
											this.updataLog(res.venueId, this.editForm.supplierId, this.editForm.contractId)
										}
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										var index = this.$keepAlive.indexOf('/manage/main.venueList')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.back()
									} else if (res && res.errCode != 0) {
										this.$message.error(res.errMsg)
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							let loading = this.$loading()
							// 判断资源点位是否多次关联同一合同，不允许多次关联同一合同
							if (this.oldContractId != this.editForm.contractId) {
								let params = {
									venueId: this.editForm.id,
									contractId: this.editForm.contractId,
								}
								this.$get(`getVenueLogByVenueIdAndContractId`, params).then(
									res => {
										loading.close()
										console.log(res)
										if (res && res.errCode === 0) {
											if (res.count > 0) {
												this.$message.error('此点位历史已关联过当前所选合同，不能重复关联，请选择未关联过的合同。')
											} else {
												this.editSave()
											}
										}
									},
									error => {
										loading.close()
										this.$message.error(error)
									}
								)
							} else {
								this.editSave()
							}
						}
					}
				})
			},
			editSave() {
				let params = {
					id: this.editForm.id,
					customName: this.editForm.customName,
					customNo: this.editForm.customNo,
					type: this.editForm.type,
					area: this.editForm.area,
					startDate: this.editForm.startDate,
					endDate: this.editForm.endDate,
					position: this.editForm.position,
					firstResourceType: this.editForm.firstResourceType,
					secResourceType: this.editForm.secResourceType,
					supplierName: this.editForm.supplierName,
					contactName: this.editForm.contactName,
					contactNumber: this.editForm.contactNumber,
					entrance: this.editForm.entrance,
					gardenId: this.editForm.gardenId,
					houseId: this.editForm.houseId,
					unitId: this.editForm.unitId,
					lift: this.editForm.lift,
					health: this.editForm.health,
					status: this.editForm.status,
					basePrice: this.editForm.basePrice,
					customPrice: this.editForm.customPrice,
					remark: this.editForm.remark,
					files: this.fileslist.toString(),
					supplierId: this.editForm.supplierId,
					contractId: this.editForm.contractId,
				}
				let loading = this.$loading()
				this.$patch(`/venue/updateVenue`, params).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							// 如果供应商id和合同id不为空，则上传记录
							if (this.editForm.supplierId != '' && this.editForm.contractId != '' && this.editForm
								.contractId != this.oldContractId) {
								this.updataLog(this.editForm.id, this.editForm.supplierId, this.editForm.contractId)
							}
							this.$message.success(this.$i18n.t('lang.lab_save_success'))
							var index = this.$keepAlive.indexOf('/manage/main.venueList')
							if (index > -1) {
								this.$keepAlive.splice(index, 1)
							}
							this.back()
						} else if (res && res.errCode != 0) {
							this.$message.error(res.errMsg)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 获取组件值
			getFile(e) {
				console.log('getFile : ' + this.fileslist)
				console.log('getFile 1 : ' + JSON.stringify(e))
				this.fileList.push({
					name: '',
					url: e
				})
			},
			// 移除图片
			removeFile(e) {
				let list1 = []
				for (let i = 0; i < this.fileList.length; i++) {
					if (this.fileList[i].url === e) {

					} else {
						list1.push(this.fileList[i])
					}
				}
				this.fileList = list1
			},
			// 获取供应商列表
			getSupplierList() {
				this.$get(`/venueSupplier?pageSize=999&pageNo=1&gardenId=` + this.$store.getters.gardenId).then(
					res => {
						if (res && res.errCode === 0) {
							console.log(res)
							this.supplierList = res.list
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			// 选择供应商
			selectSupplier(e) {
				console.log(e)
				this.editForm.contactName = this.supplierList.find(item => {
					return item.id == e
				}).contactName
				this.editForm.contactNumber = this.supplierList.find(item => {
					return item.id == e
				}).contactNumber
				this.getContractList()
				this.editForm.contractId = ''
				this.editForm.basePrice = ''
				this.editForm.contractInfo.startDate = ''
				this.editForm.contractInfo.endDate = ''
				this.showTips = false
			},
			// 获取合同列表
			getContractList() {
				this.$get(`/venueContract?contractSupplier=${this.editForm.supplierId}&pageSize=9999&pageNo=1&gardenId=` + this
					.$store.getters.gardenId).then(
					res => {
						if (res && res.errCode === 0) {
							console.log(res)
							this.contractList = res.list
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			// 选择合同
			selectContract(e) {
				console.log(e)
				if (this.editForm.supplierId == '') {
					this.$message.info('请先选择供应商')
					this.editForm.contractId = ''
					return
				}
				this.editForm.basePrice = this.contractList.find(item => {
					return item.id == e
				}).contractPrice
				this.editForm.contractInfo.startDate = this.contractList.find(item => {
					return item.id == e
				}).startDate
				this.editForm.contractInfo.endDate = this.contractList.find(item => {
					return item.id == e
				}).endDate
				// 合同到期提示
				if (nowDate > this.editForm.contractInfo.endDate) {
					this.showTips = true
				} else {
					this.showTips = false
				}
			},
			// 上传记录
			updataLog(venueId, supplierId, contractId) {
				let params = {
					venueId: venueId, // 资源点位id
					supplierId: supplierId, // 供应商id
					contractId: contractId, // 合同id
				}
				let loading = this.$loading()
				this.$post(`/venueLog`, params).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							console.log('上传记录成功')
						} else if (res && res.errCode != 0) {
							this.$message.error(res.errMsg)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			}
		}
	}
</script>

<style lang="scss">
	.editPreInfo {
		.item-input {
			width: 30%;
		}
	}
</style>